"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotFound = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const not_found_html_1 = __importDefault(require("./not-found.html"));
let NotFound = class NotFound extends vue_property_decorator_1.Vue {
};
exports.NotFound = NotFound;
exports.NotFound = NotFound = __decorate([
    (0, vue_property_decorator_1.Component)({ template: not_found_html_1.default })
], NotFound);
//# sourceMappingURL=index.js.map